var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClassfield(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1867 11.616H13.729V17.6773H17.1867V11.616Z",
    fill: "#808080"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9796 15.0737H7.62653V18.5727H11.9796V15.0737Z",
    fill: "#808080"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1257 10.7996H6.77264V13.4032H11.1257V10.7996Z",
    fill: "#808080"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4119 7.92227H15.9206L11.9984 4L8.0761 7.92227H5.58488C4.71202 7.92227 4.00024 8.6303 4.00024 9.50691V19.9026C4.00024 20.7755 4.70827 21.4872 5.58488 21.4872H18.4156C19.2885 21.4872 20.0002 20.7792 20.0002 19.9026V9.50691C19.9965 8.6303 19.2885 7.92227 18.4119 7.92227ZM11.9984 5.85437L14.0663 7.92227H9.93047L11.9984 5.85437ZM18.3856 19.9101H5.61111V9.49567H18.3856V19.9101Z",
    fill: "#808080"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassfield);
export default __webpack_public_path__ + "static/media/classfield.c3adf473a31696d55532c0e9d7a080f3.svg";
export { ForwardRef as ReactComponent };